function NotFound() {
    return (
      <>
        <header>
          <div
            className="relative min-h-screen overflow-hidden bg-center bg-cover"
            style={{
              backgroundPosition: "50%",
              backgroundImage: `url('./home_bg.jpeg')`,
            }}
          >
            <div
              className="absolute top-0 bottom-0 left-0 right-0 w-full h-full overflow-hidden bg-fixed"
              style={{ backgroundColor: `rgba(${0}, ${0}, ${0}, ${0.52})` }}
            >
              <div className="flex items-center justify-center h-full">
                <div className="px-6 text-center text-white md:px-12">
                  <h1 className="mt-0 mb-6 text-6xl font-bold text-red-500">
                    404
                  </h1>
                  <h3 className="mb-8 text-3xl font-bold">Page Not Found !</h3>
                  <h4 className="mb-8 text-2xl ">
                    The page you're looking for doesn't exist.
                  </h4>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 border-2 border-white text-white font-medium text-xs leading-tight uppercase rounded hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out"
                    data-mdb-ripple="true"
                    data-mdb-ripple-color="light"
                    onClick={() => {
                      var delayInMilliseconds = 400; //400 millisecond
  
                      setTimeout(function () {
                        window.location.href = "/";
                      }, delayInMilliseconds);
                    }}
                  >
                    Go to Home Page
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
  
  export default NotFound;
  